import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import config from '../config'
import routes from '../routes'
import { SIZES } from '../styles/theme'
import loginBtn from '../images/login-button.png'

const Page = styled.div`

  #enter-btn {
    position: fixed;
    bottom: 60%;
    left: 70%;
    color: #FFA600;
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 20px;
    font-style: italic;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      line-height: 32px;
    }
  }
  .click-login-text {
    margin-top: -12px;
    font-weight: 600;
  }

  ${SIZES.mobile} {
    #enter-btn {
      top: 60%;
      bottom: 15%;
      left: 50%;
      transform: translateX(-50%);
    }

    .click-login-text {
      font-size: 16px;
    }

  }

`

export default function WelcomePage() {
  return (
    <Page>
      <Link id="enter-btn" to={routes.lobby} className="btn">
        <img src={loginBtn} width="125px" alt="login form button"/>
        <div className="click-login-text">Click To Login</div>
      </Link>
    </Page>
  )
}
